import type { FunctionComponent } from "react";

import type { Account, DocumentRequestResponse } from "~/v2/api/rest/account";
import { normalizeDocType } from "~/v2/utils/normalizeDocType";
import { W8BenForm } from "../w8BenForm";
import { RequestedDocumentUpload } from "./RequestedDocumentUpload/RequestedDocumentUpload.connector";

interface RequestedDocumentsPresProps {
  account: Account;
  isLegalEntity: boolean;
  documentRequests: DocumentRequestResponse[];
}

export const RequestedDocuments: FunctionComponent<
  RequestedDocumentsPresProps
> = ({ account, isLegalEntity, documentRequests }) => {
  return (
    <div className="flex w-full flex-col gap-4">
      {documentRequests?.map((request) => {
        // W-8BEN is a special case, so we handle it separately
        if (normalizeDocType(request.doc_type) === "w_8ben") {
          return <W8BenForm accountId={account.id} documentRequest={request} />;
        }

        return (
          <RequestedDocumentUpload
            key={request.id}
            isLegalEntity={isLegalEntity}
            documentRequest={request}
          />
        );
      })}
    </div>
  );
};
